export default __webpack_public_path__ + "static/media/primary-care-appointment-4.8f4733c9.svg";